import { Component, Input } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumLanguages, EnumPageDisplayModes, EnumPageEntitySources } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    HTMLBody: string;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-htmlbox-dialog',
    templateUrl: './htmlbox-dialog.component.html',
    styleUrls: ['./htmlbox-dialog.component.scss']
})
export class HtmlBoxDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Input() HTMLBody: string;
    @Input() Language: string;

    constructor(A: ServiceBagService) {
        super(A, 'HtmlBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    protected override OnInitState(): void {
        this.State.HTMLBody = this.HTMLBody;
    }

    GetHtmlEditorClass() {
        const rtlClass = this.A.Screen.IsRTL() ? 'html-editor-rtl' : 'html-editor-ltr';
        return `html-text-editor ${rtlClass}`;
    }

}
